import { render, staticRenderFns } from "./LogReportDetails.vue?vue&type=template&id=00a4b263"
import script from "./LogReportDetails.vue?vue&type=script&lang=js"
export * from "./LogReportDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports